import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { REACT_APP_API_URL } from "config";

export default function ReceiptRedirect() {
  const { token } = useParams();

  useEffect(() => {
    window.location.href = `${REACT_APP_API_URL}/pickups/receipt/${token}`;
  }, [token]);

  return null;
}
